/**
 * Parses a cookie value containing feature flags
 * @param cookieValue The raw cookie value (JSON string)
 * @returns Object containing flag key-value pairs, or empty object if parsing fails
 */
export function parseCookieValue(cookieValue: string): Record<string, boolean> {
	if (!cookieValue) {
		return {};
	}

	try {
		const parsed = JSON.parse(cookieValue);

		// Validate that parsed value is an object with boolean values
		if (typeof parsed === 'object' && parsed !== null && !Array.isArray(parsed)) {
			const result: Record<string, boolean> = {};
			for (const [key, value] of Object.entries(parsed)) {
				if (typeof value === 'boolean') {
					result[key] = value;
				}
			}
			return result;
		}

		return {};
	} catch (error) {
		// Invalid JSON, return empty object
		return {};
	}
}
